export enum PlanningEventReasons {
    LEAVE = 'ABSENCE',
    SICK_LEAVE = 'MALADE',
    SEANCE = 'SEANCE',
    ON_SITE = 'STUDIO',
    NO_SEANCE = 'NO_SEANCE',
    PUBLIC_HOLIDAY = 'PUBLIC_HOLIDAY'
}